import { ATJS_STATE, DOCUMENT_MODE } from '../consts/config';
import { mockHomepageStore } from '../mock';

// dev note re home page 'store'.  When deployed and running this data is provided by the
// SSR to be on window -  it is handed into the main app as a prop and therefore is
// not fetched by componentDidMount().  To get similar non-async behaviour in dev and
// func tests the mock is simply bundled into dev build in the 'mock' module below.
// In a prod build, this mock module is replaced with an empty module to keep the data out
// of prod js.

export function get() {
  if (typeof window !== 'undefined') {
    if (process.env.MOCK === 'true') {
      console.log('Using MOCK data store');
      return mockHomepageStore;
    }
    const talPageData = window['oetal'].pageData;
    if (talPageData) {
      const state = { content: talPageData };
      // allows atjsState to override content state
      const atjsState = (window as any)[ATJS_STATE] || {};

      // detects browser as IE11
      const isIE = /*@cc_on!@*/ false || !!window.document[DOCUMENT_MODE];

      const content = { ...state.content, ...atjsState };
      return { ...state, content, isIE } as any;
    }
  }

  throw new Error(
    'Unable to provide initial state.  window["oetal"].pageData.  If running locally with non-prod build set env var MOCK=true to mock content store',
  );
}
